export default __webpack_public_path__ + "static/media/washupStep2-1.1dc6b962.png";